import { useResponsiveLayout } from '@hooks/useResponsiveLayout'
import { useMobileSidebar } from '@providers/MobileSidebarProvider'
import { IconButton, Text } from '@ui'
import React from 'react'
import { HiMenu } from 'react-icons/hi'

export const SidebarMobileToggle = ({ title }: { title: string }) => {
  const { isMobile } = useResponsiveLayout()
  const mobileSidebar = useMobileSidebar()

  if (!isMobile) return

  return (
    <div className="mb-4 flex items-center rounded-md border border-hairline bg-surface p-1">
      <IconButton aria-label="Open menu" onClick={mobileSidebar.open}>
        <HiMenu size={22} />
      </IconButton>

      <Text as="h1" variant="body" weight="semibold" align="center" truncate className="flex-1">
        {title}
      </Text>

      {/* Balances the menu button so the title stays centred. */}
      <span aria-hidden="true" className="size-10 shrink-0" />
    </div>
  )
}
